// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-chip-menu.ant-dropdown-menu {
  margin-top: 4px;
  box-shadow: unset;
}
.portal {
  background: #ffffff;
  flex: 1;
  display: flex;
  overflow: hidden;
}
.portal .home {
  padding: 20px;
}
.portal .menu .menu-toggle-button {
  width: 100%;
  border-radius: 0;
}
.portal .menu .ant-menu-inline {
  min-width: 256px;
}
.portal .menu .ant-menu-inline-collapsed {
  min-width: 0px;
}
.portal .content {
  flex: 1;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Page/Portal/Portal.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;AACF;AAEA;EACE,mBAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;AAAF;AAJA;EAOI,aAAA;AAAJ;AAPA;EAYM,WAAA;EACA,gBAAA;AAFN;AAXA;EAgBM,gBAAA;AAFN;AAdA;EAmBM,cAAA;AAFN;AAjBA;EAwBI,OAAA;EACA,YAAA;AAJJ","sourcesContent":[".user-chip-menu.ant-dropdown-menu {\n  margin-top: 4px;\n  box-shadow: unset;\n}\n\n.portal {\n  background: #ffffff;\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n\n  .home {\n    padding: 20px;\n  }\n\n  .menu {\n    .menu-toggle-button {\n      width: 100%;\n      border-radius: 0;\n    }\n    .ant-menu-inline {\n      min-width: 256px;\n    }\n    .ant-menu-inline-collapsed {\n      min-width: 0px;\n    }\n  }\n\n  .content {\n    flex: 1;\n    height: 100%;\n  }\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
